var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 30,
    viewBox: "0 0 94 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0462 0.895996L32.3124 12.1792H25.7559L26.8526 7.66916H11.75L8.19365 22.3309H23.2884L24.3851 17.8208H30.9416L28.2078 29.104H0L6.83065 0.895996H35.0462Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.097 29.096H46.4047L43.5926 20.3507H39.8404L37.7332 29.096H31.1768L37.9682 0.936523H59.7919L55.1075 20.3588H51.324L54.097 29.096ZM51.6374 7.70159H42.8876L41.4854 13.6261H50.1961L51.6374 7.70159Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3247 0.895996L62.494 29.0959H55.9297L62.7603 0.895996H69.3247Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9999 0.936523L87.2084 29.096H80.6519L83.2291 18.3786H74.5184L71.9021 29.096H65.3848L72.1763 0.936523H93.9999ZM85.8376 7.66118H77.0956L76.1556 11.6055H84.8662L85.8376 7.66118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCria);
export default __webpack_public_path__ + "static/media/LogoCria.9905f96fbc72e5cc64f9d26293b4dedd.svg";
export { ForwardRef as ReactComponent };